import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend from 'i18next-http-backend';
import i18next from 'i18next';
import type { LanguageDefinition } from '@jwp/ott-common/types/i18n';
import { filterSupportedLanguages } from '@jwp/ott-common/src/utils/i18n';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

import { NAMESPACES } from './resources';

export const DEFINED_LANGUAGES: LanguageDefinition[] = [
  {
    code: 'es',
    displayName: 'Spanish',
  },
  {
    code: 'en',
    displayName: 'English',
  },
];

const initI18n = async () => {
  const { config } = useConfigStore.getState();
  const enabledLanguages = import.meta.env.APP_ENABLED_LANGUAGES?.split(',') || [];
  const defaultLanguage = config?.custom?.defaultLanguage === 'en' ? 'en' : import.meta.env.APP_DEFAULT_LANGUAGE || 'es';

  const supportedLanguages = filterSupportedLanguages(DEFINED_LANGUAGES, enabledLanguages);

  useConfigStore.setState({ supportedLanguages });
  if (!supportedLanguages.some(({ code }) => code === defaultLanguage)) {
    throw new Error(`The default language is not enabled: ${defaultLanguage}`);
  }

  await i18next
    .use(I18NextHttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      supportedLngs: supportedLanguages.map(({ code }) => code),
      fallbackLng: defaultLanguage,
      returnEmptyString: false,
      ns: NAMESPACES,
      defaultNS: 'common',
      fallbackNS: 'common',
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'jwapp.language',
      },
      react: {
        useSuspense: false,
      },
      lng: localStorage.getItem('jwapp.language') || defaultLanguage,
    });

  const detectedLanguage = i18next.language;
  if (!supportedLanguages.some(({ code }) => code === detectedLanguage)) await i18next.changeLanguage(defaultLanguage);
};

export default initI18n;
